import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/icons/profile.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__logo" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "header__links" }
const _hoisted_6 = {
  key: 0,
  class: "header__links-text"
}
const _hoisted_7 = { class: "header__links-icons" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "header__profile",
  src: _imports_1,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SearchHeader = _resolveComponent("SearchHeader")!
  const _component_ButtonLanguage = _resolveComponent("ButtonLanguage")!
  const _component_LanguageDropdown = _resolveComponent("LanguageDropdown")!
  const _component_ButtonLogin = _resolveComponent("ButtonLogin")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RouterLink, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createBlock(_component_SearchHeader, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_RouterLink, {
                  to: { path: '/templates', query: { page: '1' } },
                  onClick: _ctx.trackHeaderTemplates
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("header.templates")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_RouterLink, {
                  to: { path: '/favourites', query: { page: '1' } },
                  onClick: _ctx.trackHeaderFavourites
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("header.favourites")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ButtonLanguage),
            _createVNode(_component_LanguageDropdown, { show: _ctx.showLanguageDropdown }, null, 8, ["show"]),
            (!_ctx.isAuthenticated)
              ? (_openBlock(), _createBlock(_component_ButtonLogin, { key: 0 }))
              : (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 1,
                  to: "/profile",
                  onClick: _ctx.trackHeaderProfile
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ])
        ])
      ])
    ])
  ]))
}